import _get from 'lodash/get';

export const getUserWeddingDate = state => _get(state, 'user.userContext.user_role_account_weddings[0].wedding_date');

export const getUserWeddingMonthYearDate = state => _get(state, 'user.userContext.user_role_account_weddings[0].wedding_month_year_date');

export const getUserContext = state => _get(state, 'user.userContext');

export const getUserRole = state => _get(state, 'user.userContext.user_role_account_weddings[0].role');

export const getAccountId = state => _get(state, 'user.userContext.user_role_account_weddings[0].account_id');

export const getOwnerFirstName = state => _get(state, 'user.userContext.user_role_account_weddings[0].owner_first_name');

export const getOwnerLastName = state => _get(state, 'user.userContext.user_role_account_weddings[0].owner_last_name');

export const getPartnerFirstName = state => _get(state, 'user.userContext.user_role_account_weddings[0].partner_first_name');

export const getPartnerLastName = state => _get(state, 'user.userContext.user_role_account_weddings[0].partner_last_name');

export const getUserWeddingGuestCount = state => _get(state, 'user.userContext.user_role_account_weddings[0].guest_count');

export const getUserId = state => _get(state, 'user.userContext.object_id');

export const getOwnerAccountUserId = state => _get(state, 'user.partnerContext[0].userObjectId');

export const getPartnerUserId = state => _get(state, 'user.partnerContext[0].partnerUserObjectId');

export const getRegistryAccountId = state => _get(state, 'user.userContext.registry_account.registry_id');

export const getInvitesAccountId = state => _get(state, 'user.userContext.invitation_account.id');

export const getUserBusinessUnitSource = state => _get(state, 'user.userContext.business_unit_source');

export const getUserCreatedAt = state => _get(state, 'user.userContext.created_at');

export const getUserHasCompletedOnboarding = state => _get(state, 'user.userContext.has_completed_onboarding');

export const getUserHasWeddingAccount = state => _get(state, 'user.userContext.has_wedding_account');

export const getUserIsGuest = state => _get(state, 'user.userContext.is_guest', false);

export default {
  getUserWeddingDate,
  getUserWeddingGuestCount,
  getUserContext,
  getUserRole,
  getPartnerFirstName,
  getPartnerLastName,
  getOwnerFirstName,
  getOwnerLastName,
  getUserId,
  getPartnerUserId,
  getRegistryAccountId,
  getInvitesAccountId,
  getUserIsGuest
};



// WEBPACK FOOTER //
// ./src/selectors/user/userSelectors.js